import has from 'lodash/has';
/**
 * Form 편집 Mixin
 * @type {Object}
 */
export default {
  data() {
    return {
      editing: {
        isEditing: false, // true면 Editor활성화 상태, false면 비활성화 상태.
        property: null, // 편집할 데이터 인덱스
        data: null, // 편집할 JSON 데이터
        originalValue: null, // 편집할 값의 기존 값
        value: null, // 편집되고 있는 값
        targetKeys: null, // 체크그룹에서 실제변경되는 인덱스값 배열
      },
    };
  },
  methods: {
    /**
     * 전달한 대상의 Editor를 제공한다.
     * @param  {object} data     [편집할 JSON 데이터]
     * @param  {string} property [편집할 데이터 인덱스, 해당 인덱스를 기준으로 수정여부 판단]
     */
    startEdit(data, property) {
      this.editing.property = property;
      this.editing.data = data;

      // 수정여부 플래그 객체 삽입
      if (!has(data, 'dirty')) {
        this.$set(data, 'dirty', false);
      }
      // if(data.modified && data.modified[property]) {
      //   // 수정된 적이있으면 수정전 오리지널값에서 오리지널벨류 가져오기
      //   // 현재는 Form은 한번 수정하면 끝이므로.. 없어되는듯
      //   this.editing.originalValue = data.modified[property];
      // } else {
      this.editing.originalValue = data[property];
      // }
      // SKT - TiAMS 자산정보 수정 (플래그에 따라 값을 value가 아닌 placeholder로 보여줘야하는 특수한 경우)
      if (property === 'assetNoSch' && this.target.assetNoSchInitFlag) {
        this.editing.value = '';
      } else {
        this.editing.value = data[property];
      }
      this.editing.isEditing = true;
    },

    /**
     * 데이터 편집정보를 업데이트한다
     * 값 변경 여부 확인 후 dirty 및 modified에 변경된 필드의 기존 값 설정
     * @param  {?} newValue [변경된 값]
     */
    updateEdit(newValue) {
      const data = this.editing.data;
      const property = this.editing.property;
      if (data && property) {
        data[property] = newValue;

        if (this.editing.originalValue === newValue) {
          // 변경 x
          data.dirty = false;
          if (has(data, 'modified') && data.modified[property]) {
            delete data.modified[property];
          }
        } else {
          // 변경
          data.dirty = true;
          if (!has(data, 'modified')) {
            data.modified = {};
          }
          data.modified[property] = this.editing.originalValue;
        }
      }
    },
    endEdit(newValue) {
      const data = this.editing.data;
      const property = this.editing.property;
      if (data) {
        data.dirty = false;

        if (has(data, 'modified') && data.modified[property]) {
          delete data.modified[property];
        }

        if (has(data, 'modified') && data.modified.length === 0) {
          delete data.modified;
        }

        this.editing = {
          isEditing: false,
          target: null,
          property: null,
          data: null,
          value: null,
          originalValue: null,
        };
      }
    },

    /**
     * 전달한 대상의 Editor를 제공한다.
     * @param  {object} data     [편집할 JSON 데이터]
     * @param  {string} property [편집할 데이터 인덱스, 해당 인덱스를 기준으로 수정여부 판단]
     * @param  {string} targetKeys [실제로 수정되는 인덱스 들, 체크박스그룹사용 ]
     */
    startRadioEdit(data, checkList, targetKeys) {
      // this.editing.property = property;
      this.editing.data = data;

      // 수정여부 플래그 객체 삽입
      if (!has(data, 'dirty')) {
        this.$set(data, 'dirty', false);
      }

      this.editing.originalValue = checkList.slice();
      this.editing.targetKeys = targetKeys;
      this.editing.isEditing = true;
    },

    /**
     * 데이터 편집정보를 업데이트한다
     * 값 변경 여부 확인 후 dirty 및 modified에 변경된 필드들의 기존 값 설정
     *
     * @param  {?} newValue [변경된 체크 리스트]
     */
    updateRadioEdit(newValue) {
      const data = this.editing.data;
      const targetKeys = this.editing.targetKeys;

      if (data && targetKeys) {
        const originalChecked = this.editing.originalValue;

        // 수정된 값들의  OriginalValue 가 저장되는 객체
        const modifiedKeys = {};

        targetKeys.forEach((prop) => {
          if (newValue.indexOf(prop) < 0) {
            // 체크가 해제됨
            // 기존 인덱스값 변경 기존 값과 비교 후 변경 판단
            data[prop] = 0;
            if (originalChecked.indexOf(prop) >= 0) {
              // 기존에 체크되었으나 해제되엇음
              modifiedKeys[prop] = 1;
            }
          } else {
            // 체크됨
            data[prop] = 1;
            if (originalChecked.indexOf(prop) < 0) {
              // 기존에 해제되어있었으나 체크됨
              modifiedKeys[prop] = 0;
            }
          }
        });

        if (Object.keys(modifiedKeys).length === 0) {
          // 변경 x
          data.dirty = false;
          if (has(data, 'modified')) {
            targetKeys.forEach((prop) => {
              if (data.modified[prop]) {
                delete data.modified[prop];
              }
            });
          }
        } else {
          // 변경
          data.dirty = true;
          if (!has(data, 'modified')) {
            data.modified = {};
          }
          Object.keys(modifiedKeys).forEach((prop) => {
            data.modified[prop] = modifiedKeys[prop];
          });
        }
      }
    },
    endRadioEdit(newValue) {
      const data = this.editing.data;
      const targetKeys = this.editing.targetKeys;

      if (data && targetKeys) {
        data.dirty = false;

        if (has(data, 'modified')) {
          targetKeys.forEach((prop) => {
            if (data.modified[prop]) {
              delete data.modified[prop];
            }
          });
        }

        if (has(data, 'modified') && data.modified.length === 0) {
          delete data.modified;
        }

        this.editing = {
          isEditing: false,
          target: null,
          property: null,
          data: null,
          value: null,
          originalValue: null,
        };
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/editingForm.js